import { render } from "./ModalEnseignant.vue?vue&type=template&id=ac231cc2&scoped=true"
import script from "./ModalEnseignant.vue?vue&type=script&lang=js"
export * from "./ModalEnseignant.vue?vue&type=script&lang=js"

import "./ModalEnseignant.vue?vue&type=style&index=0&id=ac231cc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac231cc2"]])

export default __exports__